import { Component, OnInit } from '@angular/core';
import { GridicsUseTagService } from 'src/app/core/services/gridics-use-tag.service';
import { ZCExportService } from 'src/app/core/services/zc-export.service';
import { ZoningCodeService } from 'src/app/core/services/zoning-code.service';

@Component({
    standalone: false,
    selector: 'app-zc-xlsx-export-button',
    templateUrl: './zc-xlsx-export-button.component.html',
    styleUrls: ['./zc-xlsx-export-button.component.scss']

})
export class ZcXlsxExportButtonComponent implements OnInit {
    isExporting: boolean = false;

    constructor(
        private readonly zcService: ZoningCodeService,
        private readonly zcExportService: ZCExportService,
        private readonly gridicsUseTagService: GridicsUseTagService
    ) {}

    get disabled(): boolean {
        return !this.zcService.hasZoningCode || this.isExporting;
    }

    ngOnInit(): void {}

    exportZoningCodeToXLSX() {
        this.isExporting = true;
        this.zcExportService.exportZoningCodeToXLSX(
            this.zcService.selectedZoningCode,
            this.gridicsUseTagService.gridicsUseTags.value || []
        );
        this.isExporting = false;
    }
}
